module.exports = __webpack_public_path__ + "media/packs/images/flags/BZ-9612034c25bd62ce3c2a18bbbfb3801c.png";